import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import { TrendingUp } from "react-feather";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
// import { THINKFIC_BASE_URL } from "../../../../apiConfigs/urlConfig";
import { YellowButton } from "../../../../shared/Buttons/Buttons";
import {
  enrollToThinkificCourse,
  loginToThinkificAndRedirect,
} from "../../../../store/features/Thinkific/ThikificApi";
import VideoTourCard from "../../../../pages/NewAcademicUser/Dashboard/VideoTourCard/VideoTourCard";
import { roles } from "../../../../helpers/utils/Constants/roles";
import {
  isFreeSelfPacedUser,
  isSelfPacedRole,
} from "../../../../helpers/utils/roleUtils";

const SprintSection = () => {
  const [toggleColor, setToggleColor] = useState("#fe7268");
  const [hideInSafari, setHideInSafari] = useState(false);
  const [loadingCourseid, setLoadingCourseid] = useState(0);
  const [loadingSprintid, setLoadingSprintid] = useState(0);
  const [slug, setSlug] = useState("");
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const dashState: any = useAppSelector((store: RootStore) => {
    return store.NewDashboard;
  });

  const thinkificState: any = useAppSelector((store: RootStore) => {
    return store.ThinkificSlice;
  });
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });
  const themeState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });
  const startLearning = (
    slug: string,
    courseId: number,
    id: number,
    sprintId: number
  ) => {
    setLoadingCourseid(id);
    setLoadingSprintid(sprintId);
    setSlug(slug);
    dispatch(enrollToThinkificCourse({ courseId: courseId })).then((res) => {
      dispatch(
        loginToThinkificAndRedirect({
          slug: slug,
        })
      ).then((res: any) => {
        if (res.payload) {
          console.log(res.payload.url);
          window.open(res.payload.url, "_blank");
        }
      });
    });
  };

  useLayoutEffect(() => {
    if (
      navigator.userAgent.indexOf("Safari") > -1 &&
      navigator.userAgent.indexOf("Chrome") <= -1
    ) {
      setHideInSafari(true);
    }
  }, []);

  window.addEventListener("scroll", (e) => {
    if (window.scrollY > 559 && window.scrollY < 958) {
      setToggleColor("#53C4C7");
    } else if (window.scrollY > 1351 && window.scrollY < 1751) {
      setToggleColor("#53C4C7");
    } else if (window.scrollY > 2148 && window.scrollY < 2543) {
      setToggleColor("#53C4C7");
    } else if (window.scrollY > 2940 && window.scrollY < 3334) {
      setToggleColor("#53C4C7");
    } else if (window.scrollY > 3535) {
      setToggleColor("#53C4C7");
    } else {
      setToggleColor("#fe7268");
    }
    const path: any = document.getElementById("curve-svg");
    const movingElement: any = document.getElementById("motion-demo");

    const pathLength = path?.clientHeight;

    const scroll = window.pageYOffset;
    const progress = (scroll / pathLength) * 90;
    document.body.style.setProperty("--offsetDistance", `${progress}%`);
    if (movingElement) {
      movingElement.style.animation = `move ${
        5 + scroll / 100
      }s ease-in-out infinite`;
    }
  });

  useEffect(() => {
    if (thinkificState.login_req_success) {
      setLoadingCourseid(0);
      setLoadingSprintid(0);
    }
  }, [thinkificState.login_req_success]);

  const isSelfPacedUser = isSelfPacedRole(authState?.tac_user?.role, authState);
  const freeSelfPacedUser = isFreeSelfPacedUser(authState);

  const isFreeOrSelfPacedUser = isSelfPacedUser || freeSelfPacedUser;
  const selfPacecUserClassName = isSelfPacedUser;
  const freeSelfPacedUserClassName = freeSelfPacedUser;
  const isAIBusinessAnalyst = authState?.tac_user?.all_roles?.includes(
    roles.AI_BUSINESS_ANALYST_STUDENT
  );
  return (
    <div
      className={`sprint__wrapper ${
        isFreeOrSelfPacedUser && "self__sprint__wrapper"
      }`}
    >
      {!freeSelfPacedUser && <VideoTourCard />}
      <div
        className={`custom__grid__section ${
          isFreeOrSelfPacedUser && "self__custom__grid__section"
        } ${
          freeSelfPacedUserClassName ||
          (isAIBusinessAnalyst && "free__self__paced__user")
        }`}
      >
        <div className="left_grid">
          <div className="gap_onboarding" />

          {!dashState.loading.filter_course &&
            dashState.req_success.filter_course &&
            dashState.left_sprint.map((sprint: any) => {
              return (
                <div className="sprint_left " key={sprint.id}>
                  <h1 className="sprint__title mr sprint__title__handle">
                    {" "}
                    {sprint.name}
                  </h1>
                  <p className="onboarding__description">
                    {sprint.description}
                  </p>
                  <div className="left_sprint__content__section">
                    {sprint.courses.map((course: any) => {
                      return (
                        <div key={course}>
                          <YellowButton
                            text={course.name}
                            key={course.id + 200}
                            onClick={() =>
                              startLearning(
                                course.slug,
                                course.course_id,
                                course.id,
                                sprint.id
                              )
                            }
                            animationLoading={
                              thinkificState.loading &&
                              loadingSprintid === sprint.id &&
                              loadingCourseid === course.id
                            }
                          />
                          {course.description && (
                            <p className="lessons text__transform">
                              {course.description}
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
        </div>
        {isFreeOrSelfPacedUser ? (
          <div className="gradinet__vertical__line">
            <div className="gradient__line" />
          </div>
        ) : (
          <div className="center_grid">
            <div className="curved_line__section">
              <svg
                id="curve-svg"
                height="3200px"
                style={{ overflow: "inherit" }}
                className="svg"
              >
                <defs>
                  <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" className="stop1" />
                    <stop offset="100%" className="stop2" />
                  </linearGradient>
                </defs>
                <path
                  id="curve"
                  stroke="url(#grad)"
                  fill="none"
                  strokeWidth="2.5px"
                  d="M200,3 l0,472 q0,50 -50,50 l-130,0 q-50,0 -50,50 l1,250 q-1,50 50,50 l130,0 q49,1 50,50 l0,250 q0,50 -50,50 l-130,0 q-50,0 -50,50 l1,250 q-1,50 50,50 l130,0 q49,1 50,50 l0,250 q0,50 -50,50 l-130,0 q-50,0 -50,50 l1,250 q-1,50 50,50 l130,0 q49,1 50,50 l0,250 q0,50 -50,50 l-130,0 q-50,0 -50,50 l1,250 q-1,50 50,50 l130,0 q49,1 50,50 l0,300 "
                />
              </svg>

              {!hideInSafari && (
                <div id="motion-demo" style={{ background: toggleColor }} />
              )}
            </div>
            {!freeSelfPacedUser && (
              <div className="beyond__section">
                <h1 className="sprint__title beyond__title">Beyond</h1>

                <div className="row">
                  <p className="beyond__description">
                    Here's what we have to offer you in addition to our courses.
                    Go BEYOND, broaden your horizons, and increase your
                    knowledge by reading more.
                  </p>
                  <div className="right-section">
                    <YellowButton
                      className="beyond__button__color__handle"
                      text="Advanced Tech Terms"
                      onClick={() =>
                        startLearning(
                          "advanced-tech-terms",
                          1982299,
                          2222222,
                          1
                        )
                      }
                      animationLoading={
                        thinkificState.loading && loadingCourseid === 2222222
                      }
                    />
                    <YellowButton
                      className="beyond__button__color__handle"
                      text="New Job Onboarding"
                      onClick={() =>
                        startLearning("new-agile", 1994177, 1212121212, 1)
                      }
                      animationLoading={
                        thinkificState.loading && loadingCourseid === 1212121212
                      }
                    />{" "}
                    <YellowButton
                      className="beyond__button__color__handle"
                      text="All Courses"
                      onClick={() => navigate("/user-allcourses")}
                      animationLoading={false}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="right_grid">
          <div className="margin__from__top" />

          <div
            className={`real_onboarding__section ${
              hideInSafari && "reduce__height"
            }`}
          >
            {!dashState.loading.onboarding &&
              !freeSelfPacedUser &&
              !isAIBusinessAnalyst &&
              dashState.req_success.onboarding && (
                <div className="onboarding__content__section">
                  <h1 className="sprint__title right">
                    {" "}
                    {dashState.onboarding?.onboarding?.name}
                  </h1>
                  <p className="onboarding__description">
                    {dashState.onboarding?.onboarding?.description}
                  </p>
                  <div className="onboarding__button__section">
                    {!dashState.loading.onboarding &&
                      dashState.req_success.onboarding &&
                      (() => {
                        let slug = "onboarding";
                        let courseId = 2066635;

                        if (
                          authState?.tac_user?.role ===
                          roles.SELF_PACED_PRODUCT_MANAGER_STUDENT
                        ) {
                          slug = "product-manager-self-paced-onboarding";
                          courseId = 2818425;
                        } else if (
                          authState?.tac_user?.role ===
                          roles.SELF_PACED_SCRUM_MASTER_STUDENT
                        ) {
                          slug = "scrum-master-self-paced-onboarding";
                          courseId = 1980675;
                        } else if (
                          authState?.tac_user?.role ===
                          roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT
                        ) {
                          slug = "onboarding";
                          courseId = 2066635;
                        }

                        return (
                          <YellowButton
                            text="Onboarding"
                            onClick={() =>
                              startLearning(slug, courseId, 11111111, 1)
                            }
                            animationLoading={
                              thinkificState.loading &&
                              loadingCourseid === 11111111
                            }
                          />
                        );
                      })()}
                  </div>
                  <h6 className="lessons"> lessons in this course:</h6>
                  {dashState.onboarding?.bullet_points?.map(
                    (point: any, i: number) => {
                      return (
                        <div
                          className="lesson__section"
                          key={point.description}
                        >
                          <TrendingUp className="trending__up" />
                          <span className="lesson">{point.description}</span>
                        </div>
                      );
                    }
                  )}
                </div>
              )}
          </div>
          {!dashState.loading.filter_course &&
            dashState.req_success.filter_course &&
            dashState.right_sprint.map((sprint: any) => {
              return (
                <div className="sprint_right " key={sprint.id}>
                  <h1 className="sprint__title mr right"> {sprint.name}</h1>
                  <p className="onboarding__description">
                    {sprint.description}
                  </p>
                  <div className="right_sprint__content__section">
                    {sprint.courses.map((course: any) => {
                      return (
                        <div key={course}>
                          <YellowButton
                            text={course.name}
                            key={course.id}
                            onClick={() =>
                              startLearning(
                                course.slug,
                                course.course_id,
                                course.id,
                                sprint.id
                              )
                            }
                            animationLoading={
                              thinkificState.loading &&
                              loadingSprintid === sprint.id &&
                              loadingCourseid === course.id
                            }
                          />
                          {course.description && (
                            <p className="lessons text__transform">
                              {course.description}
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default SprintSection;
